import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useUser } from '../context/UserContext';

interface AdminPanelSidebarProps {
  show: boolean;
  setShow: (show: boolean) => void;
}

export default function AdminPanelSidebar({ show, setShow }: AdminPanelSidebarProps) {
  const { user } = useUser();
  const location = useLocation();
  const current = location.pathname;

  // Menú de navegación para administrador
  const menuItems = [
    {
      category: 'Panel Principal',
      icon: 'fa-solid fa-gauge',
      items: [
        { path: '/admin-dashboard', label: 'Dashboard Admin', icon: 'fa-solid fa-tachometer-alt' },
        { path: '/dashboard', label: 'Mi Dashboard', icon: 'fa-solid fa-home' },
      ]
    },
    {
      category: 'Gestión de Miembros',
      icon: 'fa-solid fa-users',
      items: [
        { path: '/admin-afiliado', label: 'Afiliados', icon: 'fa-solid fa-user-tie' },
        { path: '/admin-asociado', label: 'Asociados', icon: 'fa-solid fa-users' },
        { path: '/add-agent', label: 'Agregar Afiliado', icon: 'fa-solid fa-user-plus' },
        { path: '/add-aso', label: 'Agregar Asociado', icon: 'fa-solid fa-user-plus' },
      ]
    },
    {
      category: 'Propiedades',
      icon: 'fa-solid fa-building',
      items: [
        { path: '/admin-property', label: 'Todas las Propiedades', icon: 'fa-solid fa-home' },
        { path: '/aprobar-propiedades', label: 'Aprobar Propiedades', icon: 'fa-solid fa-check-circle' },
        { path: '/admin-asignaciones', label: 'Asignaciones', icon: 'fa-solid fa-exchange-alt' },
        { path: '/admin-mls-sync', label: 'Sync MLS', icon: 'fa-solid fa-rotate' },
      ]
    },
    {
      category: 'Agencias y Desarrollos',
      icon: 'fa-solid fa-city',
      items: [
        { path: '/admin-inm', label: 'Agencias', icon: 'fa-solid fa-building' },
        { path: '/admin-project', label: 'Desarrollos', icon: 'fa-solid fa-city' },
      ]
    },
    {
      category: 'Capacitación',
      icon: 'fa-solid fa-graduation-cap',
      items: [
        { path: '/admin-talleres', label: 'Todos los Cursos', icon: 'fa-solid fa-list' },
        { path: '/admin-create-taller', label: 'Crear Taller', icon: 'fa-solid fa-plus-circle' },
        { path: '/escanear-asistencia', label: 'Escanear Asistencias', icon: 'fa-solid fa-qrcode' },
      ]
    },
    {
      category: 'Moderación',
      icon: 'fa-solid fa-shield-halved',
      items: [
        { path: '/aprobar-resena', label: 'Aprobar Reseñas', icon: 'fa-solid fa-star' },
      ]
    },
  ];

  return (
    <div className={`simple-sidebar sm-sidebar ${show ? 'd-block d-md-block' : 'd-none d-md-block'}`} id="admin_sidebar">
      <div className="search-sidebar_header">
        <h4 className="ssh_heading">Cerrar Menú</h4>
        <button
          className="w3-bar-item w3-button w3-large"
          onClick={() => setShow(!show)}
          aria-label="Cerrar panel de administración"
          type="button"
        >
          <i className="fa-regular fa-circle-xmark fs-5 text-muted-2" aria-hidden="true"></i>
        </button>
      </div>

      <div className="sidebar-widgets">
        <div className="dashboard-navbar">
          {/* Header del Admin */}
          <div className="d-user-avater text-center py-3" style={{ backgroundColor: '#0c2339', borderRadius: '10px', marginBottom: '15px' }}>
            <div
              className="rounded-circle bg-white d-flex align-items-center justify-content-center mx-auto mb-2"
              style={{ width: '60px', height: '60px' }}
            >
              <i className="fa-solid fa-user-shield fa-2x" style={{ color: '#0c2339' }}></i>
            </div>
            <h5 className="text-white mb-1">{user?.nombre || 'Administrador'}</h5>
            <span className="badge bg-danger">Administrador General</span>
          </div>

          {/* Navegación por categorías */}
          <div className="d-navigation">
            {menuItems.map((category, catIndex) => (
              <div key={catIndex} className="mb-3">
                <div className="px-2 py-2 mb-1" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                  <small className="text-muted fw-bold">
                    <i className={`${category.icon} me-2`}></i>
                    {category.category}
                  </small>
                </div>
                <ul className="list-unstyled ms-2">
                  {category.items.map((item, itemIndex) => (
                    <li
                      key={itemIndex}
                      className={`py-1 ${current === item.path ? 'active' : ''}`}
                    >
                      <Link
                        to={item.path}
                        className="d-flex align-items-center text-decoration-none"
                        style={{
                          color: current === item.path ? '#0c2339' : '#666',
                          fontWeight: current === item.path ? 'bold' : 'normal',
                          padding: '8px 12px',
                          borderRadius: '5px',
                          backgroundColor: current === item.path ? '#e3f2fd' : 'transparent',
                          transition: 'all 0.2s ease'
                        }}
                      >
                        <i className={`${item.icon} me-2`} style={{ width: '20px' }}></i>
                        <span>{item.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Acceso rápido a herramientas */}
          <div className="mt-4 p-3" style={{ backgroundColor: '#fff3cd', borderRadius: '10px' }}>
            <small className="text-dark fw-bold d-block mb-2">
              <i className="fa-solid fa-bolt me-2"></i>Accesos Rápidos
            </small>
            <div className="d-grid gap-2">
              <Link
                to="/admin-create-taller"
                className="btn btn-sm btn-outline-dark"
              >
                <i className="fa-solid fa-plus me-1"></i> Nuevo Taller
              </Link>
              <Link
                to="/add-agent"
                className="btn btn-sm btn-outline-dark"
              >
                <i className="fa-solid fa-user-plus me-1"></i> Nuevo Afiliado
              </Link>
            </div>
          </div>

          {/* Centro de Ayuda */}
          <div className="mt-3 p-3" style={{ backgroundColor: '#e3f2fd', borderRadius: '10px' }}>
            <Link
              to="/ayuda"
              className="d-flex align-items-center text-decoration-none text-dark"
            >
              <i className="fa-solid fa-circle-question fa-lg me-2 text-primary"></i>
              <div>
                <span className="fw-bold d-block">Centro de Ayuda</span>
                <small className="text-muted">Guías y manuales</small>
              </div>
            </Link>
          </div>

        </div>
      </div>
    </div>
  )
}
